export default state => {
  return state.fields
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/getters/orderCustomFormFields.js